import React from 'react';
import { Bot, UserCheck, Check, X, BadgeCheck } from 'lucide-react';

const SOURCE_LABEL = { transcribed_voice: 'From voice transcript', written_feedback: 'From written feedback' };

export const OriginBadge = ({ method, testId }) => (method === 'ai' ? (
  <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#3B4A8F] bg-[#EEF0FB] border border-[#D9DDF5] rounded-full px-2 py-0.5" data-testid={testId}>
    <Bot className="w-3 h-3" /> AI
  </span>
) : (
  <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#7A4B0A] bg-[#FDF3E3] border border-[#F3DFBC] rounded-full px-2 py-0.5" data-testid={testId}>
    <UserCheck className="w-3 h-3" /> Human
  </span>
));

export default function FactorTagRow({ tag, canEdit, busy, onConfirm, onRemove }) {
  const id = tag.factor_id;
  return (
    <div className="group py-3 border-b border-[#F1F5F9] last:border-0 last:pb-0 first:pt-0" data-testid={`factor-tag-${id}`} data-method={tag.method} data-confirmed={tag.confirmed ? 'true' : 'false'}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-[#0F172A] leading-snug" data-testid={`factor-tag-name-${id}`}>{tag.factor_name}</p>
          <p className="text-xs text-[#64748B]">{tag.attribute_name}</p>
        </div>
        {canEdit && (
          <div className="flex items-center gap-1 shrink-0">
            {tag.method === 'ai' && !tag.confirmed && (
              <button type="button" disabled={busy} onClick={() => onConfirm(id)}
                className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#1F684A] border border-[#CDE9DA] bg-white hover:bg-[#EDF8F2] rounded-md px-2 py-1 transition-colors disabled:opacity-50"
                data-testid={`factor-tag-confirm-${id}`}>
                <Check className="w-3 h-3" /> Confirm
              </button>
            )}
            <button type="button" disabled={busy} onClick={() => onRemove(id)} aria-label="Remove tag"
              className="p-1 rounded-md text-[#94A3B8] hover:text-[#A1272E] hover:bg-[#FFF0F0] transition-colors disabled:opacity-50"
              data-testid={`factor-tag-remove-${id}`}>
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-1.5 mt-2">
        <OriginBadge method={tag.method} testId={`factor-tag-origin-${id}`} />
        {tag.confirmed && (
          <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#1F684A] bg-[#EDF8F2] border border-[#CDE9DA] rounded-full px-2 py-0.5"
            title={tag.confirmed_by_name ? `Confirmed by ${tag.confirmed_by_name}` : undefined} data-testid={`factor-tag-confirmed-${id}`}>
            <BadgeCheck className="w-3 h-3" /> Confirmed
          </span>
        )}
        {tag.method === 'ai' && SOURCE_LABEL[tag.source] && <span className="text-[10px] text-[#94A3B8]">{SOURCE_LABEL[tag.source]}</span>}
        {tag.method === 'human' && tag.created_by_name && <span className="text-[10px] text-[#94A3B8]">Added by {tag.created_by_name}</span>}
      </div>
      {tag.evidence && <p className="text-xs text-[#475569] italic mt-2 leading-relaxed" data-testid={`factor-tag-evidence-${id}`}>“{tag.evidence}”</p>}
    </div>
  );
}
